import { USER_LOGIN, USER_LOGOUT, USER_UPDATE } from "./constants";
import { getList, loginUser, twoFactorAuthenticate } from "../api/system";
import axios from "axios";
import { $axios } from "../api/config";

export const signInUser = (values) => {
    return async (dispatch) => {
        try {
            const res = await loginUser(values);
            if(res?.responseCode == "00") {
                const resp = await $axios.get(`/getList?targetlist=role_resource&id=${res?.user_data?.roleID}`, { headers: { Authorization: `Bearer ${res?.session_token}` } });
                const data = resp?.listing ? { ...res, ...resp?.listing } : res;
                localStorage.setItem("idsp", JSON.stringify(data));
                await dispatch({
                    type: USER_LOGIN,
                    payload: data,
                });
            
                return Promise.resolve(data);
            } else {
                return Promise.reject(res);
            }
        } catch (error) {
            return Promise.reject(error);
        }
    };
};

export const signOutUser = () => {
    return async (dispatch) => {
        try {
            localStorage.removeItem("idsp");
            window.location.href = '/';
            await dispatch({
                type: USER_LOGOUT
            });
            return Promise.resolve(true);
        } catch (error) {
            console.log(error);
            return Promise.reject(error);
        }
    };
};

export const signIn = (values) => {
    return async (dispatch) => {
        try {
            const res = await twoFactorAuthenticate(values);
            if(res?.responseCode == "00") {
                const resp = await $axios.get(`/getList?targetlist=role_resource&id=${res?.user_data?.roleID}`, { headers: { Authorization: `Bearer ${res?.session_token}` } });
                const data = resp?.listing ? { ...res, ...resp?.listing } : res;
                localStorage.setItem("idsp", JSON.stringify(data));
                await dispatch({
                    type: USER_LOGIN,
                    payload: data,
                });
            
                return Promise.resolve(data);
            } else {
                return Promise.reject(res);
            }
        } catch (error) {
            return Promise.reject(error);
        }
    };
}